import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PublicLinks from './pages/public/PublicLinks';
import { getProspectLinkPagePreview, getPublicLinkPage } from './services/api';
import './styles/public-links.css';

const PublicLinksWrapper = ({ preview = false }) => {
  const { slug, prospectName } = useParams();
  const pageKey = preview ? prospectName : slug;
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const load = async () => {
      setLoading(true);
      setError('');

      try {
        const data = preview
          ? await getProspectLinkPagePreview(pageKey)
          : await getPublicLinkPage(pageKey);
        if (active) setConfig(data);
      } catch (err) {
        if (active) {
          setError(
            err?.response?.data?.error
            || (preview
              ? 'Preview de LinkPage não encontrado.'
              : 'LinkPage não encontrada ou pausada.')
          );
        }
      } finally {
        if (active) setLoading(false);
      }
    };

    if (pageKey) {
      void load();
    } else {
      setLoading(false);
      setError(preview ? 'Preview de LinkPage não encontrado.' : 'LinkPage não encontrada.');
    }

    return () => {
      active = false;
    };
  }, [pageKey, preview]);

  if (loading) {
    return (
      <main className="fsl-public-shell">
        <div className="fsl-public-state">Carregando...</div>
      </main>
    );
  }

  if (error || !config) {
    return (
      <main className="fsl-public-shell">
        <div className="fsl-public-state">{error || 'LinkPage não encontrada.'}</div>
      </main>
    );
  }

  return (
    <PublicLinks
      restaurant={{ ...config.restaurant, slug: config.restaurant?.slug || pageKey }}
      products={config.products}
      externalLinks={config.externalLinks}
      buttonOrder={config.buttonOrder}
      theme={config.theme}
    />
  );
};

export default PublicLinksWrapper;
